<template>
  <div id="app" class="ld-app-container">
    <v-app class="ld-app">
      <v-content class="ld-content">
        <body-container-component></body-container-component>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import BodyContainerComponent from './components/body_container_component.vue';
  import './css/lollicup.css';

  export default {
    components: {
      BodyContainerComponent
    },

    name: 'app'
  };
</script>

<style scoped>
  body,
  input,
  textarea,
  select,
  button {
    font-family: 'Poppins', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue